import React from 'react';
import { View } from 'react-native';
import { styled } from 'dripsy';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';

import { BaseText, RichText, Separator } from '@components';
import { Course } from '@models/Courses/CourseModel';
import { Tutorial } from '@models/Tutorials/TutorialModel';
import { IS_WEB } from '@utils';

const Container = styled(View)({
  bg: '$background0',
  padding: ['$6', '$8'],
  borderRadius: 12,
  borderWidth: 1,
  borderColor: '$background30',
});

const Title = styled(BaseText)({
  color: '$heading800',
  variant: IS_WEB ? 'text.xxlarge' : 'text.xlarge',
  fontWeight: 'semi',
});

const Description = styled(RichText)({
  color: '$text400',
  variant: IS_WEB ? 'text.medium' : 'text.small',
});

interface ICourseLessonOverviewProps {
  course: Course;
  tutorial: Tutorial;
}

export const CourseLessonOverview = observer(
  ({ course, tutorial }: ICourseLessonOverviewProps) => {
    const { t } = useTranslation();

    const lessonDescription =
      course.lessons.getLessonByTutorialId(tutorial.id)
        ?.description ?? '';

    return (
      <Container>
        <Title>{t('tutorial.lessonOverview')}</Title>
        <Separator size="$6" />
        <Description>{lessonDescription}</Description>
      </Container>
    );
  },
);
